import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { isMobile } from 'react-device-detect';
import Tooltip from 'reactstrap/lib/Tooltip';
import { usePricing } from '../../../hooks/useCalendar/useRecordBlocs/usePricing';
import { t } from '../../common/Translate';
import { FolderSection, LabelValue } from '../Elements';
import { currencySign } from '../../../Utils/currencySign';

export const PricingBloc = ({ recordId }) => {
  const {
    supervisorOffer,
    supervisorComment,
    goToPricing,
    isVisible,
    active,
    coveragePrice,
    permissionFord,
    suggestedPrice,
    isOpen,
    onClick,
    suggestedMileage,
    suggestedEntryStockDate,
    suggestedVersionName,
    monkReportStatus,
    aiReport,
    formattedDate,
    onClickAiReport,
    isOpenAiReport,
    countryPosId,
    caMonkReportStatus,
    recordStatus,
  } = usePricing(recordId);

  const toolTip = (
    <>
      <FontAwesomeIcon
        icon={faInfoCircle}
        size="1x"
        id="Tooltip-seggestedPrice"
        className="hbs-icon ml-1"
        onClick={onClick}
      />
      <Tooltip
        placement="bottom"
        isOpen={isOpen}
        target="Tooltip-seggestedPrice"
        toggle={!isMobile && onClick}
        className="suggestedPrice-toolTip"
      >
        <p>{t('suggestedPriceInformationBoxTitle')}</p>
        <LabelValue label={t('trim')} value={suggestedVersionName} />
        <LabelValue label={t('mileage')} value={suggestedMileage} />
        <LabelValue label={t('entryStockDays')} value={suggestedEntryStockDate} />
      </Tooltip>
    </>
  );

  const toolTipReport = (
    <>
      <FontAwesomeIcon
        icon={faInfoCircle}
        size="1x"
        id="Tooltip-titleAi"
        className="hbs-icon ml-1"
        onClick={onClickAiReport}
      />

      <Tooltip
        placement="bottom"
        isOpen={isOpenAiReport}
        target="Tooltip-titleAi"
        toggle={!isMobile && onClickAiReport}
      >
        <LabelValue label={`${t('aiRequestDate')} :`} value={formattedDate} />
      </Tooltip>
    </>
  );

  let autobizAiStatus = '';

  if (monkReportStatus.status === 'pending')
    autobizAiStatus = <span className="error-autobizAi font-weight-bold text-waiting">{t('aiReportOngoing')}</span>;
  else if (monkReportStatus.status === 'success')
    autobizAiStatus = <span className="error-autobizAi font-weight-bold">{t('aiReportAvailable')}</span>;
  else if (
    monkReportStatus.status === 'duplicatedData' ||
    monkReportStatus.status === 'minimumPictures' ||
    monkReportStatus.status === 'unknowError'
  )
    autobizAiStatus = <span className="error-autobizAi font-weight-bold">{t('aiReportFailed')}</span>;

  let caAutobizAiStatus = '';

  if (caMonkReportStatus.status === 'pending')
    caAutobizAiStatus = <span className="error-autobizAi font-weight-bold text-waiting">{t('aiReportOngoing')}</span>;
  else if (caMonkReportStatus.status === 'success')
    caAutobizAiStatus = <span className="error-autobizAi font-weight-bold">{t('aiReportAvailable')}</span>;
  else if (
    caMonkReportStatus.status === 'duplicatedData' ||
    caMonkReportStatus.status === 'minimumPictures' ||
    caMonkReportStatus.status === 'unknowError'
  )
    caAutobizAiStatus = <span className="error-autobizAi font-weight-bold">{t('aiReportFailed')}</span>;

  return (
    <FolderSection title={t('pricing')} dataTestid="pricing-bloc" action={goToPricing} showArrow={active}>
      {isVisible && (
        <>
          {permissionFord && coveragePrice && <LabelValue label={t('guaranteedPriceOnline')} value={coveragePrice} />}
          {suggestedPrice && (
            <LabelValue
              label={t('suggestedPrice')}
              toolTip={toolTip}
              value={currencySign(suggestedPrice, null, countryPosId)}
              active
            />
          )}
          <LabelValue label={t('offer')} value={supervisorOffer} />
          <LabelValue label={t('comment')} value={supervisorComment} />
          {aiReport &&
            ((monkReportStatus.status !== undefined && recordStatus < 40) ||
              (caMonkReportStatus.status !== undefined && recordStatus === 40)) && (
              <LabelValue
                label={t('titleAi')}
                toolTip={toolTipReport}
                value={recordStatus === 40 ? caAutobizAiStatus : autobizAiStatus}
              />
            )}
        </>
      )}
    </FolderSection>
  );
};

PricingBloc.propTypes = {
  recordId: PropTypes.number.isRequired,
};
